// Rank tier utilities
export const TIERS = [
  { name: "BRONZE",  min: 0,    color: "#CD7F32", className: "tier-bronze" },
  { name: "SILVER",  min: 1100, color: "#C0C0C0", className: "tier-silver" },
  { name: "GOLD",    min: 1300, color: "#FFD700", className: "tier-gold" },
  { name: "DIAMOND", min: 1500, color: "#00FFFF", className: "tier-diamond" },
  { name: "PRO",     min: 1700, color: "#EF4444", className: "tier-pro" },
];

export function tierForElo(elo = 1000) {
  let tier = TIERS[0];
  for (const t of TIERS) {
    if (elo >= t.min) tier = t;
  }
  return tier;
}

export function nextTier(elo = 1000) {
  const current = tierForElo(elo);
  const idx = TIERS.findIndex(t => t.name === current.name);
  return TIERS[idx + 1] || null;
}

export function progressToNext(elo = 1000) {
  const current = tierForElo(elo);
  const next = nextTier(elo);
  if (!next) return 100;
  const span = next.min - current.min;
  const into = elo - current.min;
  return Math.max(0, Math.min(100, Math.round((into / span) * 100)));
}

export function generateAvatar(seed) {
  // dicebear-style identicon — using shapes service (no upload).
  // Reliable and themed dark.
  return `https://api.dicebear.com/7.x/identicon/svg?seed=${encodeURIComponent(seed || "anon")}&backgroundType=solid&backgroundColor=121212`;
}

export const FORMAT_LABEL = {
  GAME_OF_SKATE: "Game of SKATE",
  BEST_TRICK: "Best Trick",
  SESSION_1V1: "1v1 Session",
};
